import helper from './helper'

const setEqualHeights = {
    init: function (selector, minRes, maxRes) {
        const $elems = $(selector)
        if ($elems.length) {
            const $carousel = $elems.closest('.js-carousel-main')
            this.equalizeCheck($elems, minRes, maxRes)
            $(window).on('resize', () =>
                this.equalizeCheck($elems, minRes, maxRes)
            )

            if ($carousel.length)
                $carousel.on('setPosition', () =>
                    this.equalizeCheck($elems, minRes, maxRes)
                )
        }
    },
    equalizeCheck: function ($elems, minRes, maxRes) {
        // Unset first to get proper new measurements
        this.equalizeUnset($elems)

        if (helper.getWidth() >= minRes && helper.getWidth() <= maxRes)
            this.equalizeInit($elems)
    },
    equalizeInit: function ($elems) {
        let minHeight = 0

        $elems.each(function () {
            const elemHeight = $(this).outerHeight()

            if (elemHeight > minHeight) minHeight = elemHeight
        })

        $elems.css('height', `${minHeight}px`)
    },
    equalizeUnset: function ($elems) {
        $elems.removeAttr('style')
    },
}

setEqualHeights.init('.js-service-height', 0, 639)
